<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="6"
        xl="6"
      >
        <v-card outlined>
          <v-card-title>Statistik nach Ortsfeuerwehr</v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <thead>
              <tr>
                <th>Ortsfeuerwehr</th>
                <th>Gesamt</th>
                <th>Reserviert</th>
                <th>Bestätigt</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="ort in ortsfeuerwehrList" :key="ort.name">
                <td>{{ ort.name }}</td>
                <td>{{ ort.total }}</td>
                <td>{{ ort.reserved }}</td>
                <td>{{ ort.confirmed }}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
      >
        <v-data-table
          :headers="headers"
          :items="sortedAppointments"
          :loading="appointments === null"
          item-value="id"
          class="elevation-1"
          dense
          :items-per-page="-1"
          :search="this.$store.state.general.global_search"
        >
          <template v-slot:item.date="{ item }">
            {{ new Date(item.date).toLocaleString() }}
          </template>
          <template v-slot:item.mail="{ item }">
            <v-chip
              v-if="item.mail && item.mail.length > 0"
              x-small
              @click="copyToClipboard(item.mail)"
            >
              {{ item.mail }}
            </v-chip>

          </template>
          <template v-slot:item.reserved="{ item }">
            <v-tooltip v-if="item.reserved" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <span>
                {{ item.reserved_at }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:item.confirmed="{ item }">
            <v-tooltip v-if="item.reserved && item.confirmed" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <span>
                {{ item.confirmed_at}}
              </span>
            </v-tooltip>
            <v-icon
              v-else-if="item.reserved"
              color="error"
            >
              mdi-close
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="2000">Text wurde kopiert!</v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "TerminView",
  data: () => ({

  }),
  computed: {
    appointments() {
      return this.$store.state.appointments.all;
    },
    sortedAppointments() {
      let local_appointments = this.appointments || [];
      return [...local_appointments].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
    },
    headers() {
      return [
        { text: "Datum", value: "date" },
        { text: "Ort", value: "location" },
        { text: "Name", value: "name" },
        { text: "Mail", value: "mail" },
        { text: "Ortsfeuerwehr", value: "ortsfeuerwehr" },
        { text: "Reserviert", value: "reserved" },
        { text: "Bestätigt", value: "confirmed" }
      ];
    },
    statsByOrtsfeuerwehr() {
      const stats = {};

      (this.appointments || []).forEach((appt) => {
        const ort = appt.ortsfeuerwehr || " - Frei - ";
        if (!stats[ort]) {
          stats[ort] = {
            total: 0,
            reserved: 0,
            confirmed: 0,
          };
        }
        stats[ort].total += 1;
        if (appt.reserved) stats[ort].reserved += 1;
        if (appt.reserved && appt.confirmed) stats[ort].confirmed += 1;
      });

      return stats;
    },
    ortsfeuerwehrList() {
      return Object.entries(this.statsByOrtsfeuerwehr).map(([name, data]) => ({
        name,
        ...data,
      }));
    },
  },
  methods: {
    appointments_update() {
      this.$store.dispatch("update", { "context": "/appointments" })
    },
    copyToClipboard(text) {
      // Erstelle ein unsichtbares textarea-Element
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px"; // außerhalb des sichtbaren Bereichs
      document.body.appendChild(textarea);
      // Text auswählen und kopieren
      textarea.select();
      try {
        document.execCommand("copy");
        this.snackbar = true; // Zeige Snackbar an
      } catch (err) {
        console.error("Fehler beim Kopieren in die Zwischenablage: ", err);
      }

      // textarea-Element entfernen
      document.body.removeChild(textarea);
    },
  },
  mounted() {
    this.appointments_update()
  }
};
</script>

<style scoped>

</style>
